// Admin › Routing and Admin › Departure planner — the card and the state pill both pages use.

import type { Tone } from './routingFormat';

const TONE: Record<Tone, string> = {
  ok: 'bg-emerald-500/10 text-emerald-300 border-emerald-500/30',
  warn: 'bg-amber-500/10 text-amber-300 border-amber-500/30',
  err: 'bg-red-500/10 text-red-300 border-red-500/30',
  info: 'bg-cyan-500/10 text-cyan-300 border-cyan-500/30',
  mute: 'bg-slate-500/15 text-slate-300 border-slate-500/40',
};

export function Pill({ tone, children }: { tone: Tone; children: React.ReactNode }) {
  return <span className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-[13px] font-semibold border whitespace-nowrap ${TONE[tone]}`}>{children}</span>;
}

export function Card({ title, caption, children, action }: { title: string; caption?: string; children: React.ReactNode; action?: React.ReactNode }) {
  return (
    <section className="rounded-xl border border-slate-700 bg-slate-800/50">
      <div className="px-5 py-4 border-b border-slate-700 flex items-baseline justify-between gap-4 flex-wrap">
        <div>
          <h2 className="text-[17px] font-bold text-white">{title}</h2>
          {caption && <p className="text-[13px] text-slate-400 mt-0.5">{caption}</p>}
        </div>
        {action}
      </div>
      {children}
    </section>
  );
}
